import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Container, Segment, Sticky, Grid, Input, Transition, Divider, Loader } from 'semantic-ui-react';
import { Button, Form, Icon, Message, Progress, Image } from 'semantic-ui-react';
import { Link, Redirect } from 'react-router-dom';
import { AppState } from '../context';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { dbFamMember, dbCaregivers, dbTasks } from '../firebase';


const Signup = ({ inst }) => {
  const someContext = useContext(AppState);
  const [error, setError] = useState(false);
  const [pass, setPass] = useState("");
  const [username, setUsername] = useState("");
  const [redirect, setRedirect] = useState(false)
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [phone, setPhone] = useState("")
  const {
    firstlogin,
    setFirstLogin,
    user,
    setUser,
    firsttimeuser,
    setFirsttimeuser,
    globallogged,
    setGlobalLogged,
    familyMembers,
  } = someContext;
  const contextRef = createRef();

  const PageHeader = () => {
    var header = inst ? inst : "Homecare";
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              as={Link}
              to="/"
              inverted
              content={header}
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };
  function isValid() {
    return (!isNaN(Number(phone))) && (typeof (firstName) == "string" && typeof (lastName) == "string")

  }


  function CheckPass(pass, username) {

    if (familyMembers[username]) {
      setError(true)

    }
    else if (pass && username && isValid()) {
      const k = dbTasks.push({
        "description": "Here's an example task created for you!",
        "duration": "2 minutes",
        "familyMemberID": username,
        "frequency": "Everyday",
        "importance": "High",
        "status": false,
        "taskName": "Example Task",
        "time": "10 AM",
        "caregiverId": "None"
      });

      let push = k.path['pieces_'][1];
      const tasks = {
        [push]: push || null
      }
      const Datajson = {
        "secondaryFam": "null",
        "firstName": firstName,
        "rating": "5",
        "id": username,
        "lastName": lastName,
        "phone": phone,
        "type": "primary",
        "tasks": tasks,
        "secondaryFam": "hi",
        "unassignedTasks": "null",
        "taskstofam": tasks,
        "sampletasks": tasks,
        'password': pass,
        'careBool': false
      }

      //    var temp={
      //         'id':username,
      //         'password':pass
      //     }
      dbFamMember.update({
        [username]: Datajson
      })
      setUser(username)
      setRedirect(true);
      // setFirsttimeuser(false);
      setGlobalLogged(true)
    }
  };

  function CheckPassOrg(pass, username) {
    if (familyMembers[username]) {
      setError(true)

    }
    else if (pass && username && isValid()) {
      const k = dbTasks.push({
        "description": "Here's an example task created for you!",
        "duration": "2 minutes",
        "familyMemberID": username,
        "frequency": "Everyday",
        "importance": "High",
        "status": false,
        "taskName": "Example Task",
        "time": "10 AM",
        "caregiverId": "None"
      });

      let push = k.path['pieces_'][1];
      const tasks = {
        [push]: push || null
      }
      const Datajson = {
        "secondaryFam": "null",
        "firstName": firstName,
        "rating": "5",
        "id": username,
        "lastName": lastName,
        "phone": phone,
        "type": "primary",
        "tasks": tasks,
        "secondaryFam": "hi",
        "unassignedTasks": "null",
        "taskstofam": tasks,
        "sampletasks": tasks,
        'password': pass,
        'careBool': false,
        'organization': inst
      }

      //    var temp={
      //         'id':username,
      //         'password':pass
      //     }
      dbFamMember.update({
        [username]: Datajson
      })
      setUser(username)
      setRedirect(true);
      // setFirsttimeuser(false);
      setGlobalLogged(true)
    }
  }

  var redirecturl = !inst ? `/familymembers/register/careques/${username.value}` : `/${inst}/familymembers/register/careques/${username.value}`
  return (
    <div ref={contextRef}>
      <PageHeader />
      <Sticky context={contextRef} >
        <Grid textAlign='center' style={{ height: '10vh' }} padded>
          <Divider hidden />
          <Header>
          {inst=="Samarth" ? "Please enter information for the Samarth care coordinator" : ""}
          </Header>
          <Grid.Row>
            <Grid.Column style={{ marginLeft: "30px", marginRight: "30px", maxWidth: 450 }}>
              <Progress percent={25} indicating />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column style={{ maxWidth: 450 }}>
              {!inst ? <Header as="h5">
                Homecare does not share your data/information with any 3rd party.
              </Header> : ""}
              <Form size='large' warning={error}>
                <Segment stacked>
                  <Form.Input
                    required={true}
                    onChange={(e) => { setFirstName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='First Name'
                  />
                  <Form.Input
                    required={true}
                    onChange={(e) => { setLastName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='Last Name'
                  />
                  <Form.Input
                    required={true}
                    onChange={(e) => { setPhone(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='US Phone number'
                  />
                  <Form.Input fluid icon='user' iconPosition='left' onChange={(e) => { setUsername({ value: e.target.value }) }} placeholder='Username' />
                  <Form.Input
                    onChange={(e) => { setPass({ value: e.target.value }) }}
                    fluid
                    icon='lock'
                    iconPosition='left'
                    placeholder='Password'
                    type='password'
                  />

                  <Button color='teal' fluid size='large' onClick={() => inst ? CheckPassOrg(pass.value, username.value) : CheckPass(pass.value, username.value)}>
                    Continue
        </Button>
                </Segment>
                {error ? <div style={{ maxWidth: 450 }}>
                  <Message
                    warning
                    floating
                    content="This username already exists! Please choose another"
                    size="tiny"
                  />
                </div> : ""}
              </Form>
              <Message>
                Your privacy is important to us<a href='/privacy' target="_blank"> Privacy policy</a>
              </Message>
            </Grid.Column>
          </Grid.Row>
        </Grid>


        {redirect && username ? <Redirect to={redirecturl} push={true} /> : ""}

      </Sticky>
    </div>
  );
};

export default Signup;